module.exports = "<div class=\"dv-accordion-tab-title\" ng-click=\"vmt.vma.toggleTab(vmt.tabid)\" ng-class=\"{'tab-open': vmt.vma.isTagOpen(vmt.tabid), 'tab-close': !vmt.vma.isTagOpen(vmt.tabid)}\" ng-transclude=\"title\"> {{vmt.title}} </div> <div class=\"dv-accordion-tab-content\" ng-show=\"vmt.vma.isTagOpen(vmt.tabid)\" ng-transclude=\"body\"> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/dv-accordion/dv-accordion-tab/dv-accordion-tab.html
// module id = +4Yc
// module chunks = 0